import { render } from "./FormEposNowComponent.vue?vue&type=template&id=72f673c2"
import script from "./FormEposNowComponent.vue?vue&type=script&lang=js"
export * from "./FormEposNowComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__